import { createSlice } from '@reduxjs/toolkit';
import { animateScroll } from 'react-scroll';

import { buildVehicles, setActiveVehicle } from '@utils';

const userProfileInitialState = {
  user: {
    phone: null,
    language: null,
    newsLetterOptIn: null,
    configurations: [],
    customerId: null,
    email: null,
    firstName: null,
    lastName: null,
    locale: null,
    otherAddresses: [],
    primaryBilling: {},
    primaryShipping: {},
    designs: [],
    activeVehicle: { status: 'RESERVED' },
    reservations: [],
    orders: [],
    vehicles: [],
  },
  vehiclesData: {},
  isProfileError: false,
  isProfileFetched: false,
  isProfileLoading: false,
};

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: userProfileInitialState,
  reducers: {
    profileLoading(state) {
      animateScroll.scrollTo(0, {
        duration: 400,
        smooth: 'easeInOutSine',
        ignoreCancelEvents: true,
      });

      state.isProfileError = false;
      state.isProfileFetched = false;
      state.isProfileLoading = true;
    },
    profileSuccess(state, { payload }) {
      state.user = payload;
      if (payload['infotainmentVehicles'] !== undefined) {
        state.vehiclesData = payload['infotainmentVehicles'];
      }
      if (payload['vehicles'] === undefined) {
        state.user = {
          ...state.user,
          ...buildVehicles(
            payload,
            payload['infotainmentVehicles'] || state.vehiclesData
          ),
        };
      }
      state.isProfileError = false;
      state.isProfileFetched = true;
      state.isProfileLoading = false;
    },
    profileFailure(state) {
      state.user = { ...userProfileInitialState.user };
      state.isProfileError = true;
      state.isProfileFetched = false;
      state.isProfileLoading = false;
    },
    profileReset(state) {
      state.user = { ...userProfileInitialState.user };
      state.isProfileError = false;
      state.isProfileFetched = false;
      state.isProfileLoading = false;
    },
    updateUserInfo(state, { payload }) {
      state.user.firstName = payload.firstName;
      state.user.lastName = payload.lastName;
      state.user.email = payload.email;
      state.user.phone = payload.phones.number;
    },
    updateAddress(state, { payload }) {
      state.user.primaryShipping = payload.primaryShipping;
      state.user.primaryBilling = payload.primaryBilling;
    },
    updateActiveVehicle(state, { payload }) {
      setActiveVehicle(state.user.vehicles[payload]);
      state.user.activeVehicle = {
        index: payload,
        status: ['DELIVERED', 'FULFILLED'].includes(
          state.user.vehicles[payload].status
        )
          ? 'DELIVERED'
          : 'RESERVED',
      };
    },
  },
});

export const {
  profileLoading,
  profileSuccess,
  profileFailure,
  profileReset,
  updateUserInfo,
  updateAddress,
  updateActiveVehicle,
} = userProfileSlice.actions;

export default userProfileSlice.reducer;
